// Somewhat old, but see no reason it won't work
// Taken from https://www.bennadel.com/blog/3580-using-pure-pipes-to-generate-ngfor-trackby-identity-functions-for-mixed-collections-in-angular-7-2-7.htm

interface TrackByFunctionCache {
	[property: string]: <T>(index: number, item: T) => any;
}

const cache: TrackByFunctionCache = Object.create(null);

export function trackByProperty(propertyNames: '$index'): any;
export function trackByProperty(propertyNames: string[]): any;
export function trackByProperty(propertyNames: string): any;
export function trackByProperty(propertyNames: any): any {
	let cacheKey = propertyNames;

	// Handle an array of properties (composit key)
	if (Array.isArray(propertyNames)) {
		cacheKey = propertyNames.join('->');

		if (!cache[cacheKey]) {
			cache[cacheKey] = function trackByProperty<T>(index: number, item: T): any {
				const values = [];
				for (const propertyName of propertyNames) {
					values.push(item[propertyName as keyof T]);
				}
				return values.join('->');
			};
		}

		// Handle an index as they key
	} else if (propertyNames === '$index') {
		if (!cache[cacheKey]) {
			cache[cacheKey] = function trackByProperty<T>(index: number, item: T): any {
				return index;
			};
		}

		// Default to a single property
	} else {
		if (!cache[propertyNames]) {
			cache[propertyNames] = function trackByProperty<T>(index: number, item: T): any {
				return item[propertyNames as keyof T];
			};
		}
	}

	return cache[cacheKey];
}
